/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export enum RegulationGroupType {
  NOT_SPECIFIED = "not_specified",
  RETAILER_STANDARD = "retailer_standard",
  GOVERNING_BODY = "governing_body",
  ALLERGENS = "allergens",
}
